import { Container, Row, Col } from "react-bootstrap";
import ShopAdds from "../../../components/shopAds/ShopAdds";
import BackArrow from "../../../components/backArrow";
import { useState, useEffect } from "react";
import Viewbusinessfriend from "../../../pages/UserProfile/Components/Profile_connectivity/Viewbusiness/index";
import Businessprofiletitle from "../../../components/BusinessProfile/Component/Title/businessprofiletitle";
import Rawmaterialcard from "../../../components/BusinessProfile/Component/Rawmaterialcard/Rawmaterialcard";
import Timeline from "../../../components/Timeline/timeline";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { decodeId } from "../../../utils/idObfuscator";
import { useBusinessProfileTabs } from "../../../hooks/useBusinessProfileTabs";
import useIncomingMessageNotice from "../../../hooks/useIncomingMessageNotice";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import "../../../style/incomingMessageNotice.css";

const WholesellerBusinessProfile = () => {
  const { id: rawId } = useParams();
  const id = decodeId(rawId) || rawId;
  const location = useLocation();
  const navigate = useNavigate();
  const [profileshowhide, setProfileshowhide] = useState(false);
  const { name } = useSelector((state) => state.user);
  const { receivedMessageCount, clearReceivedMessageCount } =
    useIncomingMessageNotice({ userId: name?._id, shopId: id });
  const [createPost, setCreatePost] = useState({
    shopid: id,
    userid: name?._id,
    businessType: "wholesellerShop",
    my: [
      {
        heading: "",
        content: "",
        img: [""],
        video: [""],
      },
    ],
  });

  useEffect(() => {
    setCreatePost((prev) => ({
      ...prev,
      shopid: id || prev.shopid,
      userid: name?._id || prev.userid,
      businessType: "wholesellerShop",
    }));
    if (id) localStorage.setItem("shopid", id);
  }, [id, name?._id]);

  const {
    tabsData,
    activeTab,
    handleTabSelect,
    getActiveTabData,
    loading,
  } = useBusinessProfileTabs({
    shopid: id,
    userid: name?._id,
    businessType: "wholesellerShop",
  });

  return (
    <>
      <Container>
        <Row className="align-items-start">
          <Col lg="7" className="screenHeight p-0">
            {profileshowhide ? (
              <Viewbusinessfriend
                id={id}
                profileurl="/Home-Made-Item-Userprofile"
                setProfileshowhide={setProfileshowhide}
                mybusinessType={createPost?.businessType}
                viewBusinessType={profileshowhide}
              />
            ) : (
              <div className="border b-radius">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 ms-3 me-3 mt-2">
                  <div className="ms-3">
                    <BackArrow />
                  </div>
                  <div className="d-flex align-items-center gap-2 ms-auto">
                    {receivedMessageCount > 0 && (
                      <>
                        <NotificationsActiveIcon
                          className="incoming-message-bell text-primary"
                          fontSize="small"
                          aria-hidden="true"
                        />
                        <span className="small fw-semibold text-primary">
                          {receivedMessageCount} message
                          {receivedMessageCount === 1 ? "" : "s"} received
                        </span>
                      </>
                    )}
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={() => {
                        clearReceivedMessageCount();
                        const chatParams = new URLSearchParams({
                          type: "shop",
                          profileId: id || "",
                          ...(createPost?.businessType
                            ? { businessType: createPost.businessType }
                            : {}),
                          returnTo: location.pathname,
                        });
                        const chatUrl = `/messages?${chatParams.toString()}`;
                        const newTab = window.open(chatUrl, "_blank");
                        if (!newTab) {
                          navigate("/messages", {
                            state: {
                              returnTo: location.pathname,
                              messageProfile: {
                                type: "shop",
                                profileId: id,
                                businessType: createPost?.businessType,
                              },
                            },
                          });
                        }
                      }}
                    >
                      Open chat
                    </button>
                  </div>
                </div>

                <ShopAdds />
                <Businessprofiletitle
                  name="WholeSeller Business Profile"
                  navigate="/wholesaler-owner-profile"
                  linkurl="/wholesaler-owner-profile"
                  id={id}
                />
                <Rawmaterialcard
                  id={id}
                  profileurl="/Home-Made-Item-Userprofile"
                  setProfileshowhide={setProfileshowhide}
                />
              </div>
            )}
          </Col>

          <Col
            lg="5"
            sm="12"
            className="ps-4 screenHeight"
            style={{ position: "relative" }}
          >
            <div className="border b-radius">
              <Timeline
                tabsData={tabsData}
                activeTab={activeTab}
                onTabSelect={handleTabSelect}
                tabData={getActiveTabData()}
                loading={loading}
                createPost={createPost}
                setCreatePost={setCreatePost}
                id={id}
                mybusinessType={createPost?.businessType}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default WholesellerBusinessProfile;
